import { REDUCER_NAME } from "./consts";

export const selectors = {
  selectInventoryFilter: (state) => state[REDUCER_NAME]?.inventoryFilter,
};
